import React from "react";
import PropTypes from "prop-types";
import Image from "../../image";

const ExperienceCard = ({
  bgImage,
  iconImage,
  fallbackImage,
  fallbackIcon,
  experienceTitle,
  experienceDescription,
  descriptionColor,
  isRounded,
  isRoundedTop,
  captionColor,
  captionSize,
  bgColor,
  truncateDesc
}) => {
  return (
    <>
      <div className={`${bgColor ?? "bg-transparent"}`}>
        <div className="pb-2 gvi-card-image">
          {(bgImage || fallbackImage) && (
            <Image
              imageAlt={experienceTitle}
              image={bgImage}
              sourceUrl={fallbackImage}
              imageClass={`object-cover object-center w-full h-40 border experience-tab-card-image-border-color ${
                isRounded ? "rounded-md" : ""
              } ${isRoundedTop ? "rounded-t-md" : ""}`}
            />
          )}
        </div>
        <div className="h-auto px-2 py-2 bg-transparent gvi-card-body">
          {experienceTitle && (
            <div className="flex flex-row items-center justify-start gap-2">
              {(iconImage || fallbackIcon) && (
                <Image
                  imageAlt={experienceTitle}
                  image={iconImage}
                  sourceUrl={fallbackIcon}
                  imageClass="w-[25px] h-[25px]"
                />
              )}
              <div
                className={`${
                  captionSize ? "text-[" + captionSize + "px]" : "text-sm"
                } !pb-0 not-italic lato-regular-latin font-bold ${
                  captionColor
                    ? captionColor
                    : "experience-tab-card-title-color"
                }`}
                dangerouslySetInnerHTML={{ __html: experienceTitle }}
              />
            </div>
          )}
          {experienceDescription && (
            <div
              className={`not-italic lato-regular-latin text-sm py-2 ${
                descriptionColor ? descriptionColor : "gvi-light-gray-text"
              } `}
              dangerouslySetInnerHTML={{
                __html: `${
                  truncateDesc === true
                    ? experienceDescription.substring(0, 150)
                    : experienceDescription
                }`
              }}
            />
          )}
        </div>
      </div>
    </>
  );
};

ExperienceCard.defaultProps = {
  bgImage: "",
  iconImage: "",
  fallbackImage: "",
  fallbackIcon: "",
  experienceTitle: "",
  experienceDescription: "",
  descriptionColor: "",
  isRounded: false,
  isRoundedTop: false,
  captionColor: "",
  captionSize: "",
  bgColor: "",
  truncateDesc: true
};

ExperienceCard.propTypes = {
  bgImage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  iconImage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  fallbackImage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  fallbackIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  experienceTitle: PropTypes.string,
  experienceDescription: PropTypes.string,
  descriptionColor: PropTypes.string,
  isRounded: PropTypes.bool,
  isRoundedTop: PropTypes.bool,
  truncateDesc: PropTypes.bool,
  captionColor: PropTypes.string,
  captionSize: PropTypes.string,
  bgColor: PropTypes.string
};

export default ExperienceCard;
